import React from 'react';
import { Container, Card, Alert } from 'react-bootstrap';
import { FaBan } from 'react-icons/fa';

const CoachDisabled = () => {
    return (
        <Container className="py-5" dir="rtl">
            <Card className="shadow">
                <Card.Body className="text-center">
                    <div className="mb-4">
                        <FaBan size={64} className="text-danger" />
                    </div>
                    <h2 className="mb-4">חשבונך הושעה</h2>
                    <Alert variant="danger" className="mb-4">
                        <p className="mb-0">
                            חשבונך הושעה על ידי מנהל הארגון. אנא פנה למנהל הארגון שלך למידע נוסף או לפתרון הבעיה.
                        </p>
                    </Alert>
                    <p className="text-muted">
                        אם אתה חושב שזו טעות, אנא צור קשר עם מנהל הארגון שלך.
                    </p>
                </Card.Body>
            </Card>
        </Container>
    );
};

export default CoachDisabled; 